import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, CircularProgress, useMediaQuery, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../components/sidebars/Sidebar_eneurons';
import TopNav from '../../components/TopNav_eneurons';
import { Line } from 'react-chartjs-2';
import StatisticsCards from '../../components/StatisticsCard'; // Import the new component
import imagez from '../../assets/images/medics.jpg';

import { Chart,CategoryScale, // This is the category scale for the x-axis
  LinearScale, // Linear scale for the y-axis
  LineElement,PointElement,
  Filler,Title,
  Tooltip,Legend,
} from 'chart.js';

// Register the components
Chart.register(CategoryScale, LinearScale, LineElement, PointElement, Filler, Title, Tooltip, Legend);

const DashboardEneurons = () => {
  const navigate = useNavigate();
  const [chartData, setChartData] = useState(null);
  const isMobile = useMediaQuery('(max-width:768px)');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userProfile');
    navigate('/login');
  };

  const handleNotificationClick = () => {
    alert('You have new notifications!');
  };

  useEffect(() => {
    setTimeout(() => {
      setChartData({
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
        datasets: [
          {
            label: 'Sales',
            data: [65, 59, 80, 81, 56, 55],
            borderColor: 'rgba(75,192,192,1)',
            backgroundColor: 'rgba(75,192,192,0.2)',
            fill: true,
          },
        ],
      });
    }, 2000);
  }, []);

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          ml: isMobile ? 0 : sidebarOpen ? 30 : 5,
          mt: 0,
          maxWidth: '1200px',
          mx: 'auto',
        }}
      >
        <TopNav
  onLogout={handleLogout}
  onNotificationClick={handleNotificationClick}
  toggleSidebar={toggleSidebar}
/>

<Box sx={{ mt: 2 }}> {/* Add this Box to create a gap */}
  <StatisticsCards />
</Box>

        <Box sx={{ mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={8}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  height: 350,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Sales Overview
                </Typography>
                {chartData ? (
                  <Line data={chartData} style={{ flexGrow: 1 }} />
                ) : (
                  <CircularProgress
                    sx={{ display: 'block', margin: 'auto' }}
                  />
                )}
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Paper
                elevation={3}
                sx={{
                  p: 3,
                  height: 350,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={imagez}
                  alt="Medicine"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardEneurons;
